import { CircleCheck } from "lucide-react";
import { createIcon } from "@/components/icons/create-icon";

export const CheckCircleIcon = createIcon(CircleCheck);
